import React from 'react';
import { CellMeasurer, CellMeasurerCache, Grid } from 'react-virtualized';
import { InfiniteLoader, List, } from 'react-virtualized';
import 'react-virtualized/styles.css';
import List1 from '@material-ui/core/List';
import axios from 'axios'
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import { ListItemIcon } from '@material-ui/core';
import InboxIcon from '@material-ui/icons/Inbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import _ from 'lodash';
import isEqual from 'lodash/isEqual';

import { BASE_URL_APIv4 } from 'constants/ActionTypes';

import Components from './ComponentIndex';

// import InputAdornment from '@material-ui/core/InputAdornment';
// import Tooltip from '@material-ui/core/Tooltip';
// import IconButton from '@material-ui/core/IconButton';
// import FilterListIcon from '@material-ui/icons/FilterList';

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}

class ListVirtual extends React.Component {

    state = {
        dataFeature: [],
        indexStart: 0,
        indexEnd: 20,
        totalRecord: null,
        dialogOpen: false,
        input: null,
        key: '',
        depends: ''
    }

    initDataVirtual = async () => {

        const data = {
            paging: { start: 0, length: this.props.lengthData },
            orders: { columns: [this.props.name], ascending: true }
        }
        const filter = this.props.filter || {}
        if (!_.isEmpty(filter)) {
            data.columns = filter;
        }

        let obj = JSON.stringify(data)
        const result = await axios.post(this.props.url, obj, config)
            .then(res => res)
            .catch((error) => error.response)
        if (result.data.totalRecord > 0) {
            this.setState({ dataFeature: result.data.data, totalRecord: result.data.totalRecord, indexStart: 0 })
        }
    }

    getDataDepo = async () => {
        // console.log(`getDataDepo`, this.props.companyId)
        const data = {
            paging: { start: 0, length: this.props.lengthData },
            orders: { columns: [this.props.name], ascending: true },
            columns: [
                { "name": "name", "logic_operator": "like", "value": "warehouse", "operator": "AND", "table_name": "m_trip_group_transit_point" },
                { "name": "status", "logic_operator": "=", "value": "true", "operator": "AND", "table_name": "m_trip_group_transit_point" },
                { "name": "company_id", "logic_operator": "=", "value": this.props.companyId.toString(), "operator": "AND", "table_name": "m_trip_group_transit_point" }
            ],
            joins: [
                { "name": "trip_group_transit_point", "column_results": ["name"] }
            ]
        }

        const result = await axios.post(this.props.url, data, config)
            .then(res => res)
            .catch((error) => error.response)
        // console.log(`result,`, result.data)
        if (result.data.totalRecord > 0) {
            this.setState({ input: result.data.data[0] })
        }
    }

    setDataVirtual = async () => {
        const data = {
            paging: { start: 0, length: 1 },
            orders: { columns: [this.props.name], ascending: true }
        }
        const filter = this.props.setData || {}

        if (!_.isEmpty(filter)) {
            data.columns = filter;

            let obj = JSON.stringify(data)
            const result = await axios.post(this.props.url, obj, config)
                .then(res => res)
                .catch((error) => error.response)
            if (result.data.totalRecord > 0) {
                this.setState({ input: result.data.data[0], depends: this.props.depends })
            }
        }
    }

    constructor(props) {
        super(props);
        this._rowRenderer = this._rowRenderer.bind(this);
        this._isRowLoaded = this._isRowLoaded.bind(this);
        this._loadMoreRows = this._loadMoreRows.bind(this);
    }

    async componentDidMount() {
        // const {indexStart, indexEnd} = this.state
        // const result = await axios.get(`${BASE_URL_APIv4}/transit-point?apiKey=b21df387-19fb-498b-90b3-94184c50a304&start=0&length=20`)
        //                     .then(res => res.data)
        //                     .catch((error) => error.response)
        // this.setState({dataFeature: result.data, totalRecord: result.totalRecord})
        //this.initDataVirtual();
        this.setDataVirtual();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.reset !== prevProps.reset || prevProps.spatialType !== this.props.spatialType) {
            console.log("use effect reset true", this.props.reset);
            console.log("use effect spatialType true", this.props.spatialType);
            this.setState({ input: null });
			//this.props.getData(null)
        }
        
        if (!isEqual(this.props.setData, prevProps.setData)) {
            console.log("refresh input virtual",this.props.setData)
            console.log("refresh prev virtual", prevProps.setData)
            this.setDataVirtual()
        }
    }

    _isRowLoaded({ index }) {
        const { dataFeature } = this.state
        return !!dataFeature[index];
    }

    async _loadMoreRows({ startIndex, stopIndex }) {
        // const {indexStart, indexEnd} = this.state
        // const start = indexStart + 20
        // const data = await axios.get(`${BASE_URL_APIv4}/transit-point?apiKey=b21df387-19fb-498b-90b3-94184c50a304&start=${start}&length=20`)
        //                     .then(res => res.data.data)
        //                     .catch((error) => error.response )
        // this.setState({dataFeature: [...this.state.dataFeature, ...data], indexStart: start})

        const { indexStart } = this.state
        const { totalRecord } = this.state

        const start = indexStart + this.props.lengthData

        const data = {
            paging: { start: start, length: this.props.lengthData },
            orders: { columns: [this.props.name], ascending: true }
        }

        const filter = this.props.filter || {}
        if (!_.isEmpty(filter)) {
            data.columns = filter;
        }

        let obj = JSON.stringify(data)
        if (totalRecord >= start) {
            const result = await axios.post(this.props.url, obj, config)
                .then(res => res)
                .catch((error) => error.response)
            this.setState({ dataFeature: [...this.state.dataFeature, ...result.data.data], indexStart: start })
        }
    }

    _rowRenderer({ key, index, style }) {

        const { dataFeature, input } = this.state
        let content;
        if (dataFeature[index] !== undefined) {

            content = <ListItem button key={index} style={style} onClick={() => this.handleChooseCallback(dataFeature[index])}
                className={dataFeature[index] !== null && "placeholder2"}>
                <ListItemIcon>
                    <InboxIcon />
                </ListItemIcon>
                <ListItemText primary={dataFeature[index][this.props.name]} />
            </ListItem>
        } else {
            const min = 20;
            const max = 300;
            const random = Math.floor(Math.random() * (+max - +min)) + +min;
            content = <ListItem button key={index} style={style} className="list-item">
                {/* <ListItemText primary={<LinearProgress />} /> */}
                <ListItemText primary={<div className="placeholder" style={{ width: random }} />} />
            </ListItem>
        }

        return (
            <React.Fragment>
                {content}
            </React.Fragment>
        )

    }

    handleClickOpen = async () => {
        await this.initDataVirtual();
        await this.setState({ dialogOpen: true, key: this.props.label.toLowerCase() });
    };

    handleClose = () => {
        this.setState({ dialogOpen: false, key: '' });
    };

    handleClear = () => {
        if (this.state.key == this.props.label.toLowerCase()) {
			if (this.props.primary) this.props.setReset(this.props.primary)
            this.setState({ input: null, dialogOpen: false, key: '' })  
            this.props.getData(null)
        }
    };

    handleChooseCallback = (data) => {
		if(this.props.primary) {
            console.log("change reset", this.props.reset)
			this.props.setReset(this.props.primary)
		}
        this.setState({ input: data, dialogOpen: false })
        this.props.getData(data)
    }

    handleInputDialog = async (e) => {
        // const value = e.target.value
        // const result = await axios.get(`${BASE_URL_APIv4}/transit-point?apiKey=b21df387-19fb-498b-90b3-94184c50a304&start=0&length=20&&params={"name":"${value}"}`)
        //         .then(res => res.data)
        //         .catch((error) => error.response )
        // this.setState({dataFeature: result.data, totalRecord: result.totalRecord});

        const value = e.target.value
        const { indexStart } = this.state
        const start = 0
        const data = {
            paging: { start: start, length: this.props.lengthData },
            orders: { columns: [this.props.name], ascending: true },
            columns: [{ name: this.props.name, "logic_operator": "like", value: value, "operator": "AND" }]
        }

        const filter = this.props.filter || {}
        if (!_.isEmpty(filter)) {
            data.columns = [...data.columns, ...filter];
        }

        let obj = JSON.stringify(data)
        const result = await axios.post(this.props.url, obj, config)
            .then(res => res)
            .catch((error) => error.response)
        if (result.data.totalRecord > 0) {
            this.setState({ dataFeature: result.data.data, totalRecord: result.data.totalRecord, indexStart: start });
        }
    }

    callbackDialogForm = async (data) => {
        this.setState({ input: data.data, dialogOpen: false })
        this.props.getData(data.data)


    };

    // static getDerivedStateFromProps(nextProps, prevState){

    //     if(nextProps.recordData !== prevState.dataFeature){
    //         return {
    //            dataFeature: nextProps.recordData,
    //         }
    //     }

    //     if(nextProps.countRecord !== prevState.totalRecord){
    //         return {
    //            totalRecord: nextProps.countRecord,
    //         }
    //     }

    //     return null
    // }

    render() {
        const { totalRecord, dataFeature } = this.state
        const { loadRows, inputText, countRecord, recordData } = this.props
        
        var type = 'DialogFormSales'; // example variable - will change from user input
        if (this.props.dialogForm != undefined) {
            type = this.props.dialogForm;
        }
        const ComponentToRender = Components[type];
        return (
            <React.Fragment>
                <TextField
                    {...{
                        ...(this.props.disabled !== true && { onClick: this.handleClickOpen }),
                    }}
                    disabled={this.props.disabled}
                    required={this.props.required}
                    label={this.props.label}
                    value={this.state.input !== null ? this.state.input[this.props.name] : this.props.value}
                    margin={this.props.margin}
                    fullWidth={this.props.fullWidth}
                />

                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">
                        {dataFeature.length > 0 &&
                            <TextField
                                autoFocus
                                id="name"
                                label={`Cari ${this.props.label}`}
                                type="text"
                                //onChange={inputText}
                                onChange={this.handleInputDialog}
                                fullWidth
                            />
                        }
                    </DialogTitle>
                    <DialogContent>

                        {this.state.input !== null &&
                            <DialogContentText className="placeholder2">
                                {this.state.input[this.props.name]}
                            </DialogContentText>
                        }
                        <div>
                            {dataFeature.length > 0 ? (
                                <List1>
                                    <InfiniteLoader
                                        isRowLoaded={this._isRowLoaded}
                                        //loadMoreRows={loadRows}
                                        loadMoreRows={this._loadMoreRows}
                                        //rowCount={countRecord}
                                        rowCount={totalRecord}
                                    >
                                        {({ onRowsRendered, registerChild }) => (
                                            <List
                                                height={250}
                                                onRowsRendered={onRowsRendered}
                                                ref={registerChild}
                                                //rowCount={countRecord}
                                                rowCount={totalRecord}
                                                rowHeight={50}
                                                rowRenderer={this._rowRenderer}
                                                width={500}
                                            />
                                        )}
                                    </InfiniteLoader>
                                </List1>
                            ) : (
                                <div style={{ margin: '0 0 0 40%', width: 500 }}>
                                    <i className="zmdi zmdi-alert-triangle zmdi-hc-5x" style={{ opacity: '0.3', marginLeft: 10 }}></i>
                                    <Typography>Tidak Ada Data {this.props.label}</Typography>
                                </div>

                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        {this.props.dialogForm != undefined &&
                            <Button onClick={this.showChildDialog} color="primary">
                                Tambah
                                </Button>
                        }

                        <Button onClick={this.handleClear} color="primary">
                            Hapus
                            </Button>
                        <Button onClick={this.handleClose} color="primary">
                            Batal
                            </Button>

                    </DialogActions>
                </Dialog>

                {this.props.dialogForm != undefined &&
                    <ComponentToRender
                        classes={this.props.classes}
                        idData={0}
                        closeDialog={this.callbackDialogForm}
                        showDialog={showDialog => this.showChildDialog = showDialog}
                    />
                }


            </React.Fragment>
        );
    }
}

export default ListVirtual;



// WEBPACK FOOTER //
// ./components/InputVirtual/index.js